import type { LoadingButtonProps } from "@mui/lab"

import { LoadingButton } from "@mui/lab"

const GreenButton = ({ children, sx, ...props }: LoadingButtonProps) => {
    return (
        <LoadingButton
            variant="contained"
            color="success"
            sx={{
                backgroundColor: "#1F8268 !important",
                flexGrow: { xs: 1, md: "unset" },
                minWidth: { xs: "unset", md: "300px" },
                "&:hover": { backgroundColor: "#1d7960" },
                ...sx,
            }}
            {...props}
        >
            {children}
        </LoadingButton>
    )
}

export default GreenButton
